(function () {
  'use strict';

  var optionCache = {};
  var cartPromise = null;

  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function getCart() {
    if (!cartPromise) {
      cartPromise = fetch(routesRoot() + 'cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store'
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart.js ' + res.status);
          return res.json();
        })
        .catch(function (err) {
          cartPromise = null;
          throw err;
        });
    }
    return cartPromise;
  }

  function optionLabel(productName, variantTitle) {
    var title = (variantTitle || '').replace(/\s+[—–-]\s+Hết hàng.*$/i, '').trim();
    if (!title || title === 'Default Title' || title === 'Tiêu chuẩn') return productName || '';
    return productName ? productName + ' · ' + title : title;
  }

  function parseProductPage(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var options = [];
    var seen = {};
    var items = doc.querySelectorAll('[data-nmp-bundle-item]');

    Array.prototype.forEach.call(items, function (item) {
      var promo = (item.getAttribute('data-promo-type') || 'free').toLowerCase();
      if (promo !== 'free') return;

      var select = item.querySelector('[data-nmp-bundle-variant]');
      if (!select) return;

      var nameNode = item.querySelector('.nmp__bundle-copy strong');
      var productName = nameNode ? nameNode.textContent.trim() : '';
      var imageNode = item.querySelector('.nmp__bundle-image');
      var image = imageNode ? imageNode.getAttribute('src') || '' : '';

      Array.prototype.forEach.call(select.options, function (opt) {
        if (opt.disabled) return;
        var id = String(opt.value || '').trim();
        if (!id || seen[id]) return;
        seen[id] = true;
        options.push({
          id: id,
          label: optionLabel(productName, opt.getAttribute('data-bundle-title') || opt.textContent),
          image: image
        });
      });
    });

    return options;
  }

  function loadGiftOptions(parentHandle, giftHandle) {
    var handle = parentHandle || giftHandle;
    if (!handle) return Promise.resolve([]);
    if (optionCache[handle]) return optionCache[handle];

    optionCache[handle] = fetch(routesRoot() + 'products/' + encodeURIComponent(handle), {
      credentials: 'same-origin'
    })
      .then(function (res) {
        return res.ok ? res.text() : '';
      })
      .then(function (html) {
        var options = html ? parseProductPage(html) : [];
        if (options.length || !giftHandle) return options;

        return fetch(routesRoot() + 'products/' + encodeURIComponent(giftHandle) + '.js', {
          credentials: 'same-origin'
        })
          .then(function (res) {
            return res.ok ? res.json() : null;
          })
          .then(function (product) {
            if (!product || !product.variants) return [];
            return product.variants
              .filter(function (variant) {
                return variant.available !== false;
              })
              .map(function (variant) {
                return {
                  id: String(variant.id),
                  label: optionLabel(product.title, variant.title),
                  image: product.featured_image || ''
                };
              });
          });
      })
      .catch(function () {
        return [];
      });

    return optionCache[handle];
  }

  function makeOptionButton(option, currentVariantId, onPick) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'nnom-gift-picker__opt' + (option.id === currentVariantId ? ' is-current' : '');

    if (option.image) {
      var img = document.createElement('img');
      img.src = option.image;
      img.alt = '';
      img.loading = 'lazy';
      img.width = 36;
      img.height = 36;
      button.appendChild(img);
    }

    var label = document.createElement('span');
    label.textContent = option.label + (option.id === currentVariantId ? ' (đang chọn)' : '');
    button.appendChild(label);

    button.addEventListener('click', function () {
      if (button.disabled) return;
      onPick(option.id);
    });

    return button;
  }

  function buildPanel(options, currentVariantId, onPick, onCancel) {
    var panel = document.createElement('div');
    panel.className = 'nnom-gift-picker';

    var title = document.createElement('p');
    title.className = 'nnom-gift-picker__title';
    title.textContent = 'Chọn quà tặng';
    panel.appendChild(title);

    options.forEach(function (option) {
      panel.appendChild(makeOptionButton(option, currentVariantId, onPick));
    });

    var cancel = document.createElement('button');
    cancel.type = 'button';
    cancel.className = 'nnom-gift-picker__cancel';
    cancel.textContent = 'Hủy';
    cancel.addEventListener('click', onCancel);
    panel.appendChild(cancel);

    return panel;
  }

  function panelMessage(panel, text, isError) {
    var note = panel.querySelector('.nnom-gift-picker__note');
    if (!note) {
      note = document.createElement('p');
      note.className = 'nnom-gift-picker__note';
      panel.insertBefore(note, panel.querySelector('.nnom-gift-picker__cancel'));
    }
    note.textContent = text;
    note.classList.toggle('is-error', Boolean(isError));
  }

  function setPanelBusy(panel, busy) {
    Array.prototype.forEach.call(panel.querySelectorAll('button'), function (button) {
      button.disabled = busy;
    });
    panel.classList.toggle('is-busy', busy);
    if (busy) panelMessage(panel, 'Đang cập nhật quà tặng...', false);
  }

  function collectSections() {
    var sections = ['cart-drawer', 'cart-icon-bubble'];
    var cartItemsEl = document.querySelector('cart-items');

    if (cartItemsEl && typeof cartItemsEl.getSectionsToRender === 'function') {
      try {
        cartItemsEl.getSectionsToRender().forEach(function (section) {
          if (section && section.section && sections.indexOf(section.section) === -1) {
            sections.push(section.section);
          }
        });
      } catch (e) {}
    }

    return sections;
  }

  function applyState(state, cartItemsEl) {
    if (cartItemsEl && state && state.sections) {
      var applied = false;

      cartItemsEl.getSectionsToRender().forEach(function (section) {
        var host = document.getElementById(section.id);
        var html = state.sections[section.section];
        if (!host || typeof html !== 'string') return;

        var target = section.selector ? host.querySelector(section.selector) : null;
        if (!target) target = host;

        try {
          target.innerHTML = cartItemsEl.getSectionInnerHTML(html, section.selector);
        } catch (e) {
          target.innerHTML = html;
        }
        applied = true;
      });

      if (state.sections['cart-icon-bubble']) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) {
          try {
            bubble.innerHTML = cartItemsEl.getSectionInnerHTML(state.sections['cart-icon-bubble']);
          } catch (e) {}
        }
      }

      if (applied) return;
    }

    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.reload === 'function') {
      drawer.reload();
      return;
    }

    window.location.reload();
  }

  function swapGift(gift, parentVariantId, newVariantId) {
    var properties = {};
    var source = gift.properties || {};

    Object.keys(source).forEach(function (key) {
      var value = source[key];
      if (value === null || value === undefined || String(value).length === 0) return;
      properties[key] = String(value);
    });

    properties['_NNOM bundle role'] = 'gift';
    if (parentVariantId) properties['_NNOM bundle parent'] = String(parentVariantId);

    var quantity = Math.max(1, parseInt(gift.quantity, 10) || 1);
    var sections = collectSections();
    var cartItemsEl = document.querySelector('cart-items');
    var previousIgnore = window._nnomIgnoreInterceptor;

    try { window._nnomIgnoreInterceptor = true; } catch (e) {}

    function restoreInterceptor() {
      try { window._nnomIgnoreInterceptor = previousIgnore; } catch (e) {}
      cartPromise = null;
    }

    return fetch(routesRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{
          id: Number(newVariantId),
          quantity: quantity,
          properties: properties
        }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) {
            throw new Error(body && body.description ? body.description : 'Không thể thêm quà tặng mới.');
          }
          return body;
        });
      })
      .then(function () {
        var updates = {};
        updates[gift.key] = 0;

        return fetch(routesRoot() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            updates: updates,
            sections: sections,
            sections_url: window.location.pathname
          })
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Không thể cập nhật giỏ hàng.');
        return res.json();
      })
      .then(function (state) {
        restoreInterceptor();
        applyState(state, cartItemsEl);
      })
      .catch(function (err) {
        restoreInterceptor();
        throw err;
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-nnom-gift-change]');
    if (!trigger) return;

    event.preventDefault();

    var row = trigger.closest('tr.cart-item') || trigger.closest('.cart-item');
    if (!row) return;

    var existing = row.querySelector('.nnom-gift-picker');
    if (existing) {
      existing.remove();
      return;
    }

    if (trigger.dataset.nnomGiftLoading === 'true') return;
    trigger.dataset.nnomGiftLoading = 'true';

    var originalText = trigger.textContent;
    trigger.textContent = 'Đang tải...';

    var giftKey = trigger.getAttribute('data-gift-line-key') || '';
    var currentVariantId = String(trigger.getAttribute('data-gift-variant-id') || '');
    var fallbackParentId = trigger.getAttribute('data-gift-parent-id') || '';
    var fallbackGiftHandle = trigger.getAttribute('data-gift-handle') || '';

    getCart()
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var gift = null;
        var parent = null;

        for (var i = 0; i < items.length; i++) {
          if (items[i].key === giftKey) { gift = items[i]; break; }
        }

        var parentVariantId = gift && gift.properties
          ? gift.properties['_NNOM bundle parent'] || gift.properties['_NNOM upsell parent'] || ''
          : fallbackParentId;

        if (parentVariantId) {
          for (var j = 0; j < items.length; j++) {
            var candidate = items[j];
            var props = candidate.properties || {};
            if (String(candidate.variant_id) === String(parentVariantId) && !props['_NNOM bundle parent'] && !props['_NNOM upsell parent']) {
              parent = candidate;
              break;
            }
          }
          if (!parent) {
            for (var k = 0; k < items.length; k++) {
              if (String(items[k].variant_id) === String(parentVariantId)) { parent = items[k]; break; }
            }
          }
        }

        return loadGiftOptions(parent ? parent.handle : '', gift ? gift.handle : fallbackGiftHandle)
          .then(function (options) {
            return {
              gift: gift,
              parentVariantId: parentVariantId,
              options: options
            };
          });
      })
      .then(function (data) {
        trigger.textContent = originalText;
        trigger.dataset.nnomGiftLoading = 'false';

        if (!data.gift) {
          window.alert('Không tìm thấy dòng quà tặng trong giỏ hàng. Vui lòng tải lại trang.');
          return;
        }

        if (!data.options.length) {
          window.alert('Không tải được danh sách quà tặng. Vui lòng thử lại.');
          return;
        }

        var panel = buildPanel(
          data.options,
          currentVariantId,
          function (newVariantId) {
            if (String(newVariantId) === currentVariantId) {
              panel.remove();
              return;
            }

            setPanelBusy(panel, true);
            swapGift(data.gift, data.parentVariantId, newVariantId).catch(function (err) {
              setPanelBusy(panel, false);
              panelMessage(panel, (err && err.message) || 'Không thể đổi quà tặng. Vui lòng thử lại.', true);
            });
          },
          function () { panel.remove(); }
        );

        var details = row.querySelector('.cart-item__details');
        (details || row).appendChild(panel);
      })
      .catch(function () {
        trigger.textContent = originalText;
        trigger.dataset.nnomGiftLoading = 'false';
        window.alert('Không tải được danh sách quà tặng. Vui lòng thử lại.');
      });
  });
})();
